import React, { useEffect, useRef, useState } from "react";
import { youtubeSource, ownedYoutubeEmbed } from "../../shared/youtube";
import { getVideoSource } from "../../services/videoSources";
import { externalVideoMessage, unverifiedVideoMessage } from "../../features/learning/externalVideos";
import "./style.css";

function TrackedPlayer({ contextKey, src, ...props }) {
  const playerRef = useRef(null);
  const [trackingError, setTrackingError] = useState("");
  useEffect(() => {
    let isMounted = true;
    let disposePlayer = null;
    setTrackingError("");
    window.DMLearning.attachVideo(playerRef.current, contextKey).then(
      (dispose) => {
        if (isMounted) disposePlayer = dispose;
        else dispose();
      },
      (error) => {
        if (isMounted)
          setTrackingError(
            error.message || "Não foi possível registrar o tempo da videoaula.",
          );
      },
    );
    return () => {
      isMounted = false;
      disposePlayer?.();
    };
  }, [src, contextKey]);
  const Player = /\.(mp4|webm|ogg)(?:$|[?#])/i.test(src) ? "video" : "iframe";
  // O React controla o contêiner; o SDK pode substituir o iframe interno.
  return (
    <div key={`${contextKey}:${src}`} style={{ display: "contents" }}>
      <Player
        {...props}
        ref={playerRef}
        controls
        src={window.DMLearning.videoUrl(src)}
      />
      {trackingError && <p role="status">{trackingError}</p>}
    </div>
  );
}

function ResolvedVideo({ contextKey, src, ...props }) {
  const video = youtubeSource(src);
  const [source, setSource] = useState(video ? null : { ownership: "owned" });
  useEffect(() => {
    const currentVideo = youtubeSource(src);
    if (!currentVideo) return;
    let live = true;
    getVideoSource(currentVideo.videoId).then((result) => {
      if (live) setSource(result);
    });
    return () => { live = false; };
  // O contêiner é recriado quando src/contextKey muda; não reaproveita autoria antiga.
  }, [src]);
  if (source?.ownership === "owned")
    return <TrackedPlayer contextKey={contextKey} src={video ? ownedYoutubeEmbed(src) : src} {...props} />;
  const style = { width: "100%", minHeight: 180, ...props.style };
  if (!source)
    return <div className="external-video-card" style={style} role="status">Verificando vídeo…</div>;
  return (
    <a className="external-video-card" style={style} href={video.url}
      target="_blank" rel="noopener noreferrer" data-dm-external-video="true">
      <span className="external-video-card__message">
        {source.notice || (source.ownership === "external" ? externalVideoMessage : unverifiedVideoMessage)}
      </span>
      {source.author && <small>Canal: {source.author}</small>}
      <span className="external-video-card__action">
        <span className="external-video-card__play" aria-hidden="true">▶</span>
        Assistir no YouTube ↗
      </span>
    </a>
  );
}

function LearningVideo(props) {
  return <ResolvedVideo key={`${props.contextKey}:${props.src}`} {...props} />;
}
export { LearningVideo };
